import * as React from 'react';
import { GridLayout, SelectableCard, P, Span } from '@salecycle/ui-component-library';
import { useNewCampaignState, useNewCampaignDispatch } from '../../../context/UseNewCampaignContext';
import { Features } from 'entities/campaign';
import { useFlags } from 'core/app/AppContext';
import { updateStepValidityAction } from '../../../actions';
import { Feature } from 'entities/campaign/features';
import { useTranslation } from 'react-i18next';
import { ICombinedCampaign } from '../../../entities';

export interface IProps {
  currentStep: number;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const FeaturesStep: React.FC<IProps> = ({ currentStep }: IProps) => {
  const { t } = useTranslation('campaigns');
  const dispatch = useNewCampaignDispatch();
  const { validSteps, combinedCampaign } = useNewCampaignState();
  const { hasFlag } = useFlags();

  const Sidebar = (
    <P bold={true}>
      Objective:
      <Span>{combinedCampaign.objective}</Span>
    </P>
  );

  function validateCampaignObjective(combinedCampaign: ICombinedCampaign): boolean {
    return !!combinedCampaign && !!combinedCampaign.objective;
  }

  const features = validateCampaignObjective(combinedCampaign)
    ? Features.getFeaturesForObjective(combinedCampaign.objective).map(feature => {
        const featureFlag = Features.getFeatureFlag(feature);
        return {
          featureKey: feature,
          isFlaggedOn: !!featureFlag ? !!hasFlag(featureFlag) : true,
        };
      })
    : [];

  const handleObjectiveSelect = (feature: Feature) => () => {
    dispatch({
      type: 'SET_SELECTED_FEATURE_VALUE',
      payload: { selectedFeature: feature },
    });
  };

  React.useEffect(() => {
    updateStepValidityAction(!!combinedCampaign.type, validSteps, currentStep, dispatch);
  }, [combinedCampaign.type]);

  return (
    <GridLayout
      heading={t('newCampaigns.features.heading')}
      childWidth={250}
      showSidebar={true}
      sidebar={Sidebar}
      sidebarHeading={t('newCampaigns.sidebar.heading')}
    >
      {features.map(
        t =>
          t.isFlaggedOn && (
            <SelectableCard
              key={`typePanel-${t.featureKey}`}
              heading={t.featureKey}
              icon={Features.getIcon(t.featureKey)}
              description={Features.getDescription(t.featureKey)}
              isSelected={t.featureKey === combinedCampaign.type}
              onClick={handleObjectiveSelect(t.featureKey)}
            />
          ),
      )}
    </GridLayout>
  );
};
